import React from 'react';
// import { FaMedal, FaMoneyCheckAlt, FaClock } from 'react-icons/fa';


const CommitmentSection = () => {
  return (
    <div
    className="container my-5 text-center"
    style={{ fontFamily: "Barlow Condensed" }}
  >
    <div className="row g-4 justify-content-center">
      {[
        {
          img: "assets/Images/z1.png",
          title: "Quality",
          desc: "While budget is a top priority, we never compromise on quality.",
          bg: "bg-white",
          textColor: "text-dark",
        },
        {
          img: "assets/Images/z2.png",
          title: "Budget",
          desc: "To prioritize our clients' budgets, we offer our popular 10K bathroom pricing model.",
          bg: "",
          textColor: "text-white",
          style: { backgroundColor: "#c9a13f" },
        },
        {
          img: "assets/Images/z3.png",
          title: "Time",
          desc: "We've streamlined the renovation process to complete bathroom projects in just one week.",
          bg: "",
          textColor: "text-white",
          style: { backgroundColor: "#000" },
        },
      ].map((card, i) => (
        <div className="col-12 col-sm-6 col-lg-4 d-flex" key={i} data-sal="slide-left" data-sal-duration="2000" data-sal-delay={i * 300}>
          <div data-sal="slide-left" data-sal-duration="2000" data-sal-delay={i * 300}
            className={`shadow p-4 rounded h-100 w-100 d-flex flex-column align-items-center justify-content-between ${card.bg} ${card.textColor}`}
            style={{ minHeight: "320px", ...(card.style || {}) }}
          >
            <img src={card.img} alt="" style={{ height: "100px" }} className="mb-0" />
              <h4 className="fw-semibold">{card.title}</h4>
            <div className='p-4'>
              <p>{card.desc}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
  
  );
};

export default CommitmentSection;
